<template>
  <div>
    <m-list-output-fields></m-list-output-fields>
    <div :class="{ 'summar-box-2': isUi2 }">      
      <div class="card card-margin">
        <p class="demo-price-block-top demo-price-text">
          Available Records:
          <span data-test="summary-info-perPrice" style="margin-right: 10px">{{
            order.TotalAvailableQty | numberFormat("", 0)
          }}</span>
        </p>
        <p class="demo-price-block demo-price-text">
          Selected Quantity:
          <span data-test="summary-info-perPrice" style="margin-right: 10px">{{
            order.TotalDesiredQty | numberFormat("", 0)
          }}</span>
        </p>
        <p class="demo-price-block demo-price-text">
          Price Per Record:
          <span data-test="summary-info-perPrice" style="margin-right: 10px">{{
            order.CostPrice | numberFormat("$", 5)
          }}</span>
        </p>
        <m-list-usage :isUi2="true" v-if="order.ListType!==260"></m-list-usage>
        <m-order-total></m-order-total>
        <div v-show="showPromotion" class="summary-promotion">
          <h3 class="summary-title">Promotion Code</h3>
          <div class="promotion-form">
            <b-input
              placehodle="summer"
              placeholder="Enter Code"
              v-model.lazy.trim="promotionCode"
              @input.native="promotionChange"
              data-test="summary-info-promotionCode"
              class="code-style"
            />
            <b-btn variant="primary" class="prop-btn" @click="applyPromotionCode"
              >Apply</b-btn
            >
          </div>
          <b-alert class="promot-alter" :show="showErrorPromotion" variant="danger"
            >The code is not valid.</b-alert
          >
          <b-alert class="promot-alter" :show="showSuccessPromotion" variant="success"
            >Promo code has been applied. Deducted: {{order.PromotionAmount | numberFormat("$", 2)}}</b-alert
          >
        </div>
        <b-row
          v-if="datasource.hasOutputFields"
          data-test="summary-info-hasOutput"
          class="summary-output-fields"
        >
          <b-col class="link-style mb-2">
            <b-link @click="showBreakdown"
              >> See what's included in list output with option to add more
              info.</b-link
            >
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import MListOutputFields from "@/components/summary/MListOutputFields";
import MErrorText from "@/components/common/MerrorText";
import MListUsage from "@/components/summary/MListUsage";
import MOrderTotal from "@/components/summary/MOrderTotal";
export default {
  components: {
    MListOutputFields,
    MErrorText,
    MListUsage,
    MOrderTotal
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPromotionSuccess: true,
      promotionCodeIsNaN: false,
      showErrorPromotion: false,
      showSuccessPromotion: false,
      promotionCodeInput: "",
      promotion: { PromotionName: "text" },
    };
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    orderContact() {
      return this.$store.state.order.OrderContactInformation || {};
    },
    showError() {
      return this.$store.getters["summary/showError"];
    },
    datasource() {
      return this.$store.getters["config/datasource"];
    },
    promotionCode: {
      get() {
        this.promotionCodeInput = this.order.PromoCode || "";
        return this.order.PromoCode || "";
      },
      set(val) {
        this.promotionCodeInput = val;
      },
    },
    showPromotion() {
      return true;
    }
  },
  methods: {
    
    showBreakdown() {
      this.$root.$emit("bv::show::modal", "listoutputfields");
    },
    
    promotionChange(e) {
      this.promotionCodeIsNaN = e.target.value === "";
      if(this.promotionCodeIsNaN){
        this.showSuccessPromotion = false;
        this.showErrorPromotion = false;
      }
    },
    applyPromotionCode() {
      this.showErrorPromotion = false;
      this.showSuccessPromotion = false;
      if (this.promotionCodeInput === "") {
        this.promotionCodeIsNaN = true;
        return;
      }      
      this.$http
        .post("PlaceOrder.aspx/GetPromotion", {
          listtype: this.order.ListType,
          promotionCode: this.promotionCodeInput,
        })
        .then(
          (resp) => {
            this.$store.commit("summary/saveKey", [
              "Promotion",
              resp.body.d.DataSource,
            ]);

            if (resp.body.d.DataSource !== null) {
              this.showSuccessPromotion = true;
              this.$store.commit("order/saveKey", [
                "PromoCode",
                this.promotionCodeInput,
              ]);
              this.promotion = resp.body.d.DataSource;
            } else {
              this.showErrorPromotion = true;
              this.$store.commit("order/saveKey", ["PromoCode", ""]);
            }
            this.$store.dispatch("order/calculatePrice");
          },
          (resp) => {
            this.showErrorPromotion = true;
            this.promotionCodeInput = "";
            this.$store.commit("order/saveKey", [
              "PromoCode",
              this.promotionCodeInput,
            ]);
            this.$store.commit("summary/saveKey", ["Promotion", null]);

            // this.$store.dispatch('order/calculatePrice')
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.more-output-link {
  font-size: 12px;
}

.high {
  font-weight: bold;
  color: $color-primary;
}

.demo-block {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  transition: 0.2s;
  width: 500px;
  margin-bottom: 10px;
  margin: 10px auto;
}

.item {
  padding-top: 8px;
  font-size: 13px;
}


.list-name-input-container {
  margin-bottom: 16px;
}

.demo-price-block-top {
  margin-top: 16px;
  margin-left: 16px;
}

.demo-price-block {
  margin-left: 16px;
}

.demo-price-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 9px;
}
.input-wrapper {
  display: flex;
  justify-content: space-between;
}
.left {
  margin-right: 10px;
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 10px auto;
}
.link-style {
  margin-left: 16px;
}

.gray-input input[type="text"]::placeholder,
.gray-input input[type="number"]::placeholder,
.gray-input input[type="password"]::placeholder {
  color: #ca4343 !important;
}

.promot-text {
  font-size: 13px;
  color: $color-primary-light;
}

.promotion-form {
  display: flex;
}

.code-style {
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 24px;
  width: 20rem;
}
.promot-alter{
  margin: 0px 16px 8px 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/summary/MSummaryInfo.vue